import { isIsoDate } from '../validation/is-iso-date.function';
import { isIsoDateTime } from '../validation/is-iso-date-time.function';
import { isIsoDateTimeTz } from '../validation/is-iso-date-time-tz.function';
import { IsoDate, IsoDateTime, IsoDateTimeTz } from '../../types/iso-date';
import { deconstructDate } from '../helper/deconstruct-date.function';

/**
 * Extracts the 4-digit year from an ISO 8601 date or date-time string.
 *
 * Supported inputs:
 * - Date-only: YYYY-MM-DD
 * - Date-time (no tz): YYYY-MM-DDTHH:mm:ss(.fraction[1-6])?
 * - Date-time with tz: YYYY-MM-DDTHH:mm:ss(.fraction[1-6])?(Z|±HH:MM)
 *
 * Returns the numeric year (e.g., 2025).
 * Throws if the input is not a valid ISO date/date-time in one of the above forms.
 */
export function getYear<T extends IsoDate | IsoDateTime | IsoDateTimeTz>(input: T): number {
  const {year} = deconstructDate(input);
  return year;
}

